import { TCompanyInformationPayload } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const validateCompanyShareableLinkToken = (axios: IAxiosInstance) => {
  return async (body: { accessToken: string }) => {
    const response = await axios.noRetry.post<{
      data: TCompanyInformationPayload;
    }>("/api/validateCompanyShareableLinkToken", body);
    return response.data.data;
  };
};
